(function () {
  const fpMessages = {"en":{"quick_cart":"Quick add to cart","ready_order":"Ready to order","add_cart":"Add to cart","unavailable":"Unavailable"},"de":{"quick_cart":"Schnell zum Warenkorb hinzufügen","ready_order":"Bereit zum Bestellen","add_cart":"In den Warenkorb","unavailable":"Nicht verfügbar"},"fr":{"quick_cart":"Ajout rapide au panier","ready_order":"Prêt à commander","add_cart":"Ajouter au panier","unavailable":"Indisponible"}};
  const fpLanguage = (document.documentElement.lang || "en").split("-")[0];
  const fpTranslate = key => (fpMessages[fpLanguage] || fpMessages.en)[key] || fpMessages.en[key];
  const fpPersonalizeLabel = ({ en: 'Personalize', de: 'Personalisieren', fr: 'Personnaliser' })[fpLanguage] || 'Personalize';

  var customWords = [
    'custom',
    'personalized',
    'personalised',
    'portrait',
    'your pet',
    'pet photo',
    'photo upload'
  ];
  var readyOnlyWords = [
    'tipsy tail',
    'happy hour hound',
    'lounge dog',
    'western pup',
    'bold entrance',
    'crimson contrast',
    'all in golden retriever'
  ];

  function text(value) {
    return (value || '').toString().toLowerCase();
  }

  function productSignals() {
    var title = text(document.querySelector('h1') && document.querySelector('h1').textContent);
    var canonical = text(document.querySelector('link[rel="canonical"]') && document.querySelector('link[rel="canonical"]').href);
    var collections = text(window.ph_product_collections || '');
    return {
      title: title,
      canonical: canonical,
      collections: collections,
      combined: [title, canonical, collections].join(' ')
    };
  }

  function isCustomProduct() {
    var signals = productSignals();
    if (!signals.canonical.includes('/products/')) return false;
    if (readyOnlyWords.some(function (word) { return signals.combined.includes(word); })) return false;
    return customWords.some(function (word) { return signals.combined.includes(word); });
  }

  function closestBlock(node) {
    if (!node) return null;
    return node.closest('p, .product-form__input, .product__text, .product-form__buttons, .shopify-block, div') || node;
  }

  function markUploadBlocks() {
    var labels = Array.prototype.slice.call(document.querySelectorAll('p, label, .product__text, .product-form__input'));
    labels.forEach(function (node) {
      if (/upload.+pet.+photo|upload.+photo|choose file/i.test(node.textContent || '')) {
        closestBlock(node).classList.add('codex-custom-only');
      }
    });

    Array.prototype.slice.call(document.querySelectorAll('.uploadcare--widget, button.uploadcare--widget__button_type_open')).forEach(function (node) {
      closestBlock(node).classList.add('codex-custom-only');
    });
  }

  function improveCustomFieldOrder(customProduct) {
    var nameInput = document.querySelector('#custom_name, input[name="properties[Name to print]"]');
    var mainForm = document.querySelector('form.shopify-product-form');
    var addButton = mainForm && mainForm.querySelector('button[name="add"], .add-to-cart-button');
    var quantity = mainForm && mainForm.querySelector('quantity-selector, .quantity-selector, input[name="quantity"]');
    var nameBlock = closestBlock(nameInput);

    if (!nameInput || !nameBlock) return;

    nameBlock.classList.add('codex-personalization-field', 'codex-custom-only');
    nameInput.setAttribute('autocomplete', 'off');

    if (customProduct && mainForm) {
      var anchor = quantity || addButton;
      var anchorParent = anchor && anchor.parentNode;
      if (anchor && anchorParent && mainForm.contains(anchor)) {
        if (!mainForm.contains(nameBlock)) {
          anchorParent.insertBefore(nameBlock, anchor);
        } else if (nameBlock.parentNode === anchorParent && nameBlock.compareDocumentPosition(anchor) & Node.DOCUMENT_POSITION_PRECEDING) {
          anchorParent.insertBefore(nameBlock, anchor);
        }
      }
    }
  }

  function hideReadyMadePersonalization(customProduct) {
    document.body.classList.toggle('codex-product-is-custom', customProduct);
    document.body.classList.toggle('codex-product-is-ready', !customProduct);
  }

  function setupStickyPurchaseBar() {
    if (window.innerWidth > 749 || document.querySelector('.codex-mobile-sticky-buy')) return;

    var forms = Array.prototype.slice.call(document.querySelectorAll('form.shopify-product-form, product-form form, form[action*="/cart/add"]'));
    var mainForm = forms.find(function (form) {
      return form.querySelector('button[name="add"], .add-to-cart-button, button[type="submit"]');
    });
    var addButton = mainForm && mainForm.querySelector('button[name="add"], .add-to-cart-button, button[type="submit"]');
    if (!mainForm || !addButton) return;

    // Variant rendering can replace the real purchase button. Never keep a detached target.
    function currentAddButton() {
      var nativeCard = document.querySelector('fiorpaw-personalisation');
      if (nativeCard) mainForm = nativeCard.closest('form');
      addButton = mainForm && mainForm.querySelector('button[name="add"], .add-to-cart-button, button[type="submit"]');
      return addButton;
    }

    // Recommendations may render before the main price during a variant update.
    // Only mirror the price belonging to this purchase form.
    function currentProductPrice() {
      var section = mainForm && mainForm.closest('.shopify-section');
      return section && section.querySelector('.price, .product-price, [data-price], .product__price');
    }

    // Read the existing form rules without submitting or changing the upload state.
    function firstIncompleteField() {
      var card = mainForm && mainForm.querySelector('fiorpaw-personalisation');
      if (!card) return null;
      var photos = Array.from(card.querySelectorAll('[data-fp-photo]'));
      var invalidPhoto = photos.find(function (photo) {
        if (typeof card.photoError === 'function') return !!card.photoError(photo);
        return photo.required && !photo.files.length;
      });
      if (invalidPhoto) return invalidPhoto;
      if (photos.reduce(function (bytes, photo) { return bytes + (photo.files[0]?.size || 0); }, 0) > 20 * 1024 * 1024) return photos[0];
      return Array.from(card.querySelectorAll('[data-fp-text]')).find(function (field) {
        return (field.required && !field.value.trim()) || !field.validity.valid;
      }) || null;
    }

    function focusField(field) {
      field.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      field.focus({ preventScroll: true });
    }

    var bar = document.createElement('div');
    bar.className = 'codex-mobile-sticky-buy';
    bar.setAttribute('aria-label', fpTranslate('quick_cart'));

    var titleNode = document.querySelector('h1');
    currentAddButton();
    var priceNode = currentProductPrice();
    var copy = document.createElement('div');
    copy.className = 'codex-mobile-sticky-buy__copy';
    var stickyTitle = document.createElement('span');
    stickyTitle.textContent = titleNode ? titleNode.textContent.trim() : fpTranslate('ready_order');
    var stickyAmount = document.createElement('strong');
    stickyAmount.textContent = priceNode ? priceNode.textContent.trim().replace(/\s+/g, ' ') : '';
    copy.append(stickyTitle, stickyAmount);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'codex-mobile-sticky-buy__button';
    button.textContent = (addButton.textContent || fpTranslate('add_cart')).trim() || fpTranslate('add_cart');
    button.addEventListener('click', function () {
      var target = currentAddButton();
      if (!target) return;
      var incomplete = firstIncompleteField();
      if (incomplete) {
        focusField(incomplete);
        sync();
        return;
      }
      // One activation, through the existing validated product form.
      if (!target.disabled && target.getAttribute('aria-disabled') !== 'true') target.click();
      sync();
    });

    bar.appendChild(copy);
    bar.appendChild(button);
    document.body.appendChild(bar);
    document.body.classList.add('codex-has-mobile-sticky-buy');

    function sync() {
      if (!currentAddButton()) {
        bar.classList.remove('is-visible');
        bar.hidden = true;
        bar.inert = true;
        bar.setAttribute('aria-hidden', 'true');
        button.disabled = true;
        return;
      }
      var rect = addButton.getBoundingClientRect();
      var card = mainForm.querySelector('fiorpaw-personalisation');
      var editing = document.activeElement && document.activeElement.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]');
      var overlayOpen = document.querySelector('dialog[open], details.menu-drawer-container[open]');
      var show = window.innerWidth <= 749 && !editing && !overlayOpen && (rect.bottom < 0 || rect.top > window.innerHeight);
      var pending = mainForm.closest('product-form-component')?.hasAttribute('data-fp-cart-pending');
      var disabled = pending || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true' || !!card?.variantPending;
      bar.classList.toggle('is-visible', show);
      bar.hidden = !show;
      bar.inert = !show;
      bar.setAttribute('aria-hidden', String(!show));
      button.disabled = disabled;
      button.textContent = pending ? ({ en: 'Adding…', de: 'Wird hinzugefügt…', fr: 'Ajout…' }[fpLanguage] || 'Adding…') : disabled ? ((addButton.textContent || fpTranslate('unavailable')).trim() || fpTranslate('unavailable')) : firstIncompleteField() ? fpPersonalizeLabel : ((addButton.textContent || fpTranslate('add_cart')).trim() || fpTranslate('add_cart'));
      var currentPrice = currentProductPrice();
      var stickyPrice = copy.querySelector('strong');
      if (currentPrice && stickyPrice) stickyPrice.textContent = currentPrice.textContent.trim().replace(/\s+/g, ' ');
    }

    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    document.addEventListener('variant:update', function () { window.setTimeout(sync, 0); });
    document.addEventListener('variant:selected', function () { window.setTimeout(sync, 0); });
    document.addEventListener('fp:cart-settled', sync);
    document.addEventListener('cart:update', function () { window.setTimeout(sync, 0); });
    document.addEventListener('input', sync);
    document.addEventListener('focusin', sync);
    document.addEventListener('focusout', function () { window.setTimeout(sync, 0); });
    document.addEventListener('toggle', sync, true);
    document.addEventListener('click', function () { window.setTimeout(sync, 0); });
    document.addEventListener('change', function (event) {
      if (mainForm && mainForm.contains(event.target)) window.setTimeout(sync, 80);
    });
  }

  function run() {
    if (!document.querySelector('link[rel="canonical"][href*="/products/"]')) return;
    var customProduct = isCustomProduct();
    try {
      markUploadBlocks();
      improveCustomFieldOrder(customProduct);
      hideReadyMadePersonalization(customProduct);
    } catch (error) {
      document.body.classList.add('codex-mobile-helper-partial');
    }
    setupStickyPurchaseBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    run();
    window.setTimeout(run, 800);
  });
  window.addEventListener('resize', function () {
    if (document.querySelector('link[rel="canonical"][href*="/products/"]')) setupStickyPurchaseBar();
  });
})();

